import myFlowFactory from "flow/factories/myFlowFactory";
import ICLICommand from "flow/interfaces/ICLICommand";

export default {
    name: "x-get",
    description:
        "Writes out response from get operation using current Protocol, Hostname and Port combinded with provided Path and Segment.",
    options: [],
    arguments: [
        {
            name: "pathAndSegment",
            description: "Path and Segment to use with current Protocol, Hostname and Port.",
            type: "string"
        }
    ],
    callback: function (writer, optsAndArgs) {
        const protocolHostNameAndPort = window.location.origin;
        const protocolHostNameAndPortAndPath = protocolHostNameAndPort + window.location.pathname;

        if (optsAndArgs.pathAndSegment == undefined) {
            writer.output.writeLine("Current URI: " + window.location.href);

            return { input: "" };
        }

        const protocolHostNameAndPortAndCustomPath = protocolHostNameAndPort + optsAndArgs.pathAndSegment;

        const myFlow = myFlowFactory.createMyFlow({ id: "get-url", baseUrl: protocolHostNameAndPortAndPath }, {});
        const dfd = myFlow.deferred();

        myFlow
            .get(protocolHostNameAndPortAndCustomPath, null, "html", true)
            .done((view: string) => {
                writer.output.writeLine(view);

                dfd.resolve({ input: "" });
            })
            .fail(function (object) {
                if (object && object.statusText) {
                    writer.error.writeLine(
                        "Failed with status text: '" +
                            object.statusText +
                            "'. If possible, check browser console log for errors."
                    );
                } else {
                    writer.error.writeLine("Failed. If possible, check browser console log for errors.");
                }

                dfd.resolve({ input: "" });
            });

        return dfd.promise();
    }
} as ICLICommand;
